import Container, { Service } from "typedi";
import { RouteConfig, NavigationGuardNext } from "vue-router";
import IBaseModule from "../common/contracts/modules/base-module.interface";
import learning from '../learning/stores/learning.store';
import GtrStorage from "@/modules/common/services/storage.service";
import LearningService from "@/modules/learning/services/learning.service";
import NotificationService from "@/modules/common/services/notification.service";

@Service()
export default class LearningModule implements IBaseModule {
    store(): object {
        return {
            learning
        }
    }
    routes(): RouteConfig[] {
        return [
            {
                path: '/:course_uuid',
                name: 'learning.index',
                props: true,
                component: () => import('@/modules/learning/views/layout.vue'),
                beforeEnter: async (to, from, next: NavigationGuardNext) => {
                    const course_uuid = to.params.course_uuid;

                    const user_session_str = Container.get(GtrStorage).getItem('user_session');
                    const user_session = user_session_str ? JSON.parse(user_session_str) : null;

                    if (!user_session) {
                        next({
                            name: 'registration.login.root',
                            params: { event_identifier: to.params.event_identifier || course_uuid }
                        });
                        return;
                    }

                    if (!course_uuid) {
                        next(false); // Block navigation if course_uuid is missing
                        return;
                    }

                    try {
                        const learningService = Container.get(LearningService);
                        const event = await learningService.getEvent(course_uuid);

                        if (event?.module_type === "SCORM COURSE") {
                            const returnUrl = `${window.location.origin}/scorm/completed`;
                            const launchUrl = await learningService.launchScormCourse(event.uuid, event.uuid, returnUrl);
                            window.location.href = launchUrl;
                            return;                           
                        }
                    } catch (error) {
                        const message = error instanceof Error ? error.message : String(error);
                        Container.get(NotificationService).error(message);
                    }
                    next();
                },
                children: [
                    {
                        path: 'dashboard',
                        name: 'learning.dashboard',
                        meta: {
                            title: 'Dashboard',
                            requireAuth: false
                        },
                        props: true,
                        component: () => import('@/modules/learning/views/dashboard.vue')
                    },
                    {
                        path: 'chapter',
                        name: 'learning.chapters',
                        props: true,
                        component: () => import('@/modules/learning/views/chapters.index.vue'),
                        beforeEnter: (to, from, next) => {
                            const user_session_str = Container.get(GtrStorage).getItem('user_session');
                            const user_session = user_session_str ? JSON.parse(user_session_str) : null;

                            if (!user_session) {
                                next({ name: 'registration.login.root', params: { event_identifier: to.params.event_identifier || to.params.course_uuid } });
                            } else if (!to.params.course_uuid) {
                                next(false); // Block navigation if course_uuid is missing
                            } else {
                                next();
                            }
                        },
                        children: [
                            {
                                path: ':chapter_uuid',
                                name: 'chapter.view',
                                props: true,
                                component: () => import('@/modules/learning/views/chapter.vue'),
                                children: [
                                    {
                                        path: ':content_type/:content_id',
                                        name: 'learning.content',
                                        meta: {
                                            title: 'Lesson',
                                            requireAuth: true
                                        },
                                        props: true,
                                        component: () => import('@/modules/learning/views/content.vue')
                                    }
                                ]
                            }
                        ]
                    }
                ]
            },
            {
                path: '/scorm/completed',
                name: 'scorm.completed',
                component: () => import('@/modules/learning/views/ScormCompleted.vue')
            }
        ];
    }
}
